import clsx, { type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Inserts CSS classes conditionally and avoids conflicts between them.
 *
 * @param {...ClassValue[]} classes The CSS classes to be applied to the element.
 * @returns {string} The specified CSS classes without conflicts and applied based on conditions.
 */
export function cn (...classes: ClassValue[]): string {
  return twMerge(clsx(classes))
}
